import React, { memo } from 'react'

import { Button, CubeCheck, Divider, ExternalLink, Icon, Trash } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { string, func, bool } from 'prop-types'

import { iconSize } from 'Pods/ThreeDStudio/constants'
import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'

import { NOOP } from 'Utils/stableDefaults'

const setAsMainIcon = <Icon svgComponent={CubeCheck} color="dark" size={iconSize} />
const deleteIcon = <Icon svgComponent={Trash} color="dark" size={iconSize} />
const externalLinkIcon = <Icon notSpaced svgComponent={ExternalLink} color="dark" size={iconSize} />

const formatCreatedAt = (isoString) =>
  new Date(isoString).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  })

function Menu({
  createdAt = '',
  onSetAsMain: handleSetAsMain = NOOP,
  onDelete: handleDelete = NOOP,
  onViewSourceItem: handleViewSourceItem = NOOP,
  isDisabled = false,
  sourceItemUrl = undefined,
}) {
  const t = useTranslation()

  return (
    <div className="variation-menu">
      <span className="variation-menu__created-at cgt-caption">
        {t('viewerSidebar.enhance.variations.menu.created', { date: formatCreatedAt(createdAt) })}
      </span>
      <Divider />
      <Button
        type="ghost"
        variant="with-icon"
        icon={setAsMainIcon}
        size="small"
        customClass="variation-menu__button"
        onClick={handleSetAsMain}
        disabled={isDisabled}
      >
        {t('viewerSidebar.enhance.variations.menu.setAsMain')}
      </Button>
      <Button
        type="ghost"
        variant="with-icon"
        icon={deleteIcon}
        size="small"
        customClass="variation-menu__button"
        onClick={handleDelete}
        disabled={isDisabled}
      >
        {t('viewerSidebar.enhance.variations.menu.delete')}
      </Button>
      {sourceItemUrl && (
        <>
          <Divider />
          <a
            className="variation-menu__link cgt-button-text-base"
            href={sourceItemUrl}
            target="_blank"
            rel="noopener noreferrer"
            onClick={handleViewSourceItem}
          >
            {t('viewerSidebar.enhance.variations.menu.viewInMarketplace')}
            {externalLinkIcon}
          </a>
        </>
      )}
    </div>
  )
}

Menu.propTypes = {
  createdAt: string,
  onSetAsMain: func,
  onDelete: func,
  onViewSourceItem: func,
  isDisabled: bool,
  sourceItemUrl: string,
}

export default memo(Menu)
